<template>
    <div :name="`name${data.qid}`"  class="test_question list">
        <div class="title" 
            :style="{
                fontSize: bandingstyle.appearance.fontStemSize+'px',
                color:bandingstyle.appearance.fontStemColor,
                fontWeight: bandingstyle.appearance.fontStemBold,
                fontStyle: bandingstyle.appearance.fontStemItalic,
                textDecoration: bandingstyle.appearance.fontStemUnderline
            }"
        >   
            <span v-if="data.mustanswer" class="required"></span>
            <HtmlClickImgEnlarge :content="data.questionsName"/>
        </div>
        <div class="input_box">
            <!-- 单选 -->
            <div v-if="data.questionsTypeId == '8'" >
                <template v-if="data.groupingOptionList && data.groupingOptionList.length > 0">
                    <div class="group-list" v-for="item in data.groupingOptionList" :key="item.gid">
                        <p class="group-title">{{item.groupName}}</p>
                        <el-radio-group 
                            v-model="data.userAnswer" 
                            class="option-box group-radio"
                            @change="userAnswerChange"
                        >
                            <template v-for="info in item.optionList" >
                                <el-radio 
                                    v-if="info.show == undefined || info.show == true"
                                    class="option"
                                    :key="info.oid" 
                                    :label="info.oid"
                                    :style="{
                                        fontSize: bandingstyle.appearance.fontOptionSize+'px !important',
                                        color:bandingstyle.appearance.fontOptionColor,
                                        fontWeight: bandingstyle.appearance.fontOptionBold,
                                        fontStyle: bandingstyle.appearance.fontOptionItalic,
                                        textDecoration: bandingstyle.appearance.fontOptionUnderline,
                                        width: `${100 / data.showcolnum}%`
                                    }"
                                > <HtmlClickImgEnlarge :content="info.labelName"/>
                                </el-radio>
                                <div 
                                    :key="`op${info.oid}`"
                                    v-if="info.haveInput && data.userAnswer == info.oid"
                                    class="other-input">
                                    <el-input
                                        size="medium"
                                        :placeholder="$t('UserAnswer.PleaseEnter')"
                                        v-model="info.inputValue"
                                        >
                                    </el-input>
                                </div>
                            </template>
                        </el-radio-group>
                    </div>
                    <div class="group-list" v-if="data.optionList.length > 0">
                        <p class="group-title">其他</p>
                        <el-radio-group 
                            v-model="data.userAnswer" 
                            class="option-box group-radio"
                            @change="userAnswerChange"
                        >
                            <template v-for="info in data.optionList">
                                <el-radio 
                                    v-if="info.show == undefined || info.show == true"
                                    class="option"
                                    :key="info.oid" 
                                    :label="info.oid"
                                    :style="{
                                        fontSize: bandingstyle.appearance.fontOptionSize+'px !important',
                                        color:bandingstyle.appearance.fontOptionColor,
                                        fontWeight: bandingstyle.appearance.fontOptionBold,
                                        fontStyle: bandingstyle.appearance.fontOptionItalic,
                                        textDecoration: bandingstyle.appearance.fontOptionUnderline,
                                        width: `${100 / data.showcolnum}%`
                                    }"
                                ><HtmlClickImgEnlarge :content="info.labelName"/>
                                </el-radio>
                                <div 
                                    :key="`op${info.oid}`" 
                                    v-if="info.haveInput && data.userAnswer == info.oid"
                                    class="other-input">
                                    <el-input
                                        size="medium"
                                        :placeholder="$t('UserAnswer.PleaseEnter')"
                                        v-model="info.inputValue"
                                        >
                                    </el-input>
                                </div>
                            </template>
                        </el-radio-group>
                    </div>
                </template>
                <el-radio-group 
                    v-else
                    v-model="data.userAnswer" 
                    class="option-box group-radio"
                    @change="userAnswerChange"
                >
                    <template v-for="info in data.optionList" >
                        <el-radio 
                            v-if="info.show == undefined || info.show == true"
                            class="option"
                            :key="info.oid" 
                            :label="info.oid"
                            :style="{
                                fontSize: bandingstyle.appearance.fontOptionSize+'px !important',
                                color:bandingstyle.appearance.fontOptionColor,
                                fontWeight: bandingstyle.appearance.fontOptionBold,
                                fontStyle: bandingstyle.appearance.fontOptionItalic,
                                textDecoration: bandingstyle.appearance.fontOptionUnderline,
                                width: `${100 / data.showcolnum}%`
                            }"
                        ><HtmlClickImgEnlarge :content="info.labelName"/>
                        </el-radio>
                        <div 
                            :key="`op${info.oid}`"
                            v-if="info.haveInput && data.userAnswer == info.oid"
                            class="other-input">
                            <el-input
                                size="medium"
                                :placeholder="$t('UserAnswer.PleaseEnter')"
                                v-model="info.inputValue"
                                >
                            </el-input>
                        </div>
                    </template>
                </el-radio-group>
            </div>
            <!-- 多选 -->
            <div v-else-if="data.questionsTypeId == '10'" >
                <template v-if="data.groupingOptionList && data.groupingOptionList.length > 0">
                    <div class="group-list" v-for="item in data.groupingOptionList" :key="item.gid">
                        <p class="group-title">{{item.groupName}}</p>
                        <el-checkbox-group
                            v-model="data.userAnswerArr" 
                            class="option-box group-checkbox"
                            @change="userAnswerChange"
                        >
                            <template v-for="info in item.optionList" >
                                <el-checkbox 
                                    v-if="info.show == undefined || info.show == true"
                                    class="option" 
                                    :key="info.oid" 
                                    :label="info.oid"
                                    :disabled="data.validateMsg.indexOf('最多') != -1 
                                        && data.validate 
                                        && data.userAnswerArr.indexOf(info.oid) == -1
                                    "
                                    :style="{
                                        fontSize: bandingstyle.appearance.fontOptionSize+'px !important',
                                        color:bandingstyle.appearance.fontOptionColor,
                                        fontWeight: bandingstyle.appearance.fontOptionBold,
                                        fontStyle: bandingstyle.appearance.fontOptionItalic,
                                        textDecoration: bandingstyle.appearance.fontOptionUnderline,
                                        width: `${100 / data.showcolnum}%`
                                    }"
                                ><HtmlClickImgEnlarge :content="info.labelName"/>
                                </el-checkbox>
                                <div 
                                    :key="`op${info.oid}`" 
                                    v-if="info.haveInput && data.userAnswerArr.indexOf(info.oid) !== -1"
                                    class="other-input">
                                    <el-input
                                        size="medium"
                                        :placeholder="$t('UserAnswer.PleaseEnter')"
                                        v-model="info.inputValue"
                                        >
                                    </el-input>
                                </div>
                            </template>
                        </el-checkbox-group>
                    </div>
                    <div class="group-list" v-if="data.optionList.length > 0">
                        <p class="group-title">其他</p>
                        <el-checkbox-group
                            v-model="data.userAnswerArr" 
                            class="option-box group-checkbox"
                            @change="userAnswerChange"
                        >
                            <template v-for="info in data.optionList" >
                                <el-checkbox 
                                    v-if="info.show == undefined || info.show == true"
                                    class="option" 
                                    :key="info.oid" 
                                    :label="info.oid"
                                    :disabled="data.validateMsg.indexOf('最多') != -1 
                                        && data.validate 
                                        && data.userAnswerArr.indexOf(info.oid) == -1
                                    "
                                    :style="{
                                        fontSize: bandingstyle.appearance.fontOptionSize+'px !important',
                                        color:bandingstyle.appearance.fontOptionColor,
                                        fontWeight: bandingstyle.appearance.fontOptionBold,
                                        fontStyle: bandingstyle.appearance.fontOptionItalic,
                                        textDecoration: bandingstyle.appearance.fontOptionUnderline,
                                        width: `${100 / data.showcolnum}%`
                                    }"
                                ><HtmlClickImgEnlarge :content="info.labelName"/>
                                </el-checkbox>
                                <div 
                                    :key="`op${info.oid}`" 
                                    v-if="info.haveInput && data.userAnswerArr.indexOf(info.oid) !== -1"
                                    class="other-input">
                                    <el-input
                                        size="medium"
                                        :placeholder="$t('UserAnswer.PleaseEnter')"
                                        v-model="info.inputValue"
                                        >
                                    </el-input>
                                </div>
                            </template>
                        </el-checkbox-group>
                    </div>
                </template>
                <el-checkbox-group
                    v-else
                    v-model="data.userAnswerArr" 
                    class="option-box group-checkbox"
                    @change="userAnswerChange"
                >
                    <template v-for="info in data.optionList" >
                        <el-checkbox 
                            v-if="info.show == undefined || info.show == true"
                            class="option" 
                            :key="info.oid" 
                            :label="info.oid"
                            :disabled="data.validateMsg.indexOf('最多') != -1 
                                && data.validate 
                                && data.userAnswerArr.indexOf(info.oid) == -1
                            "
                            :style="{
                                fontSize: bandingstyle.appearance.fontOptionSize+'px !important',
                                color:bandingstyle.appearance.fontOptionColor,
                                fontWeight: bandingstyle.appearance.fontOptionBold,
                                fontStyle: bandingstyle.appearance.fontOptionItalic,
                                textDecoration: bandingstyle.appearance.fontOptionUnderline,
                                width: `${100 / data.showcolnum}%`
                            }"
                        ><HtmlClickImgEnlarge :content="info.labelName"/>
                        </el-checkbox>
                        
                        <div 
                            :key="`op${info.oid}`" 
                            v-if="info.haveInput && data.userAnswerArr.indexOf(info.oid) !== -1"
                            class="other-input">
                            <el-input
                                size="medium"
                                :placeholder="$t('UserAnswer.PleaseEnter')"
                                v-model="info.inputValue"
                                >
                            </el-input>
                        </div>
                    </template>
                </el-checkbox-group>
            </div>
            
            <!-- 判断  -->
            <el-radio-group 
                v-if="data.questionsTypeId == '12'" 
                v-model="data.userAnswer" 
                class="option-box judge-option-box"
                @change="userAnswerChange"
            >
                <template v-for="info in data.optionList" >
                    <el-radio 
                        v-if="info.show == undefined || info.show == true"
                        class="option"
                        :key="info.oid" 
                        :label="info.oid"
                        :style="{
                            fontSize: bandingstyle.appearance.fontOptionSize+'px !important',
                            color:bandingstyle.appearance.fontOptionColor,
                            fontWeight: bandingstyle.appearance.fontOptionBold,
                            fontStyle: bandingstyle.appearance.fontOptionItalic,
                            textDecoration: bandingstyle.appearance.fontOptionUnderline,
                                        width: `${100 / data.showcolnum}%`
                        }"
                    ><HtmlClickImgEnlarge :content="info.labelName"/>
                    </el-radio>
                    <div 
                        :key="`op${info.oid}`" 
                        v-if="info.haveInput && data.userAnswer == info.oid"
                        class="other-input">
                        <el-input
                            size="medium"
                            :placeholder="$t('UserAnswer.PleaseEnter')"
                            v-model="info.inputValue"
                            >
                        </el-input>
                    </div>
                </template>
            </el-radio-group>

            
            <!-- 下拉题 -->
            <el-select 
                :popper-append-to-body="false" 
                size="small" 
                :placeholder="$t('UserAnswer.PleaseSelect')" 
                v-else-if="data.questionsTypeId == '9'" 
                v-model="data.userAnswer" 
                @change="userAnswerChange">
                <template v-for="info in data.optionList" >
                    <el-option
                        v-if="info.show == undefined || info.show == true"
                        :key="info.oid" 
                        :label="$functions.filterHtmlTag(info.labelName)"
                        :value="info.oid">
                        <HtmlClickImgEnlarge :content="info.labelName"/>
                    </el-option>
                </template>
            </el-select>
            <div v-show="data.validate && data.validateMsg.indexOf('最多') == -1" class="form-item__error">{{data.validateMsg}}</div>
        </div>
    </div>
</template>

<script>
import HtmlClickImgEnlarge from '@/components/myComponents/htmlClickImgEnlarge.vue'
export default {
    components: {
        HtmlClickImgEnlarge
    },
    props: {
        data: {},
        bandingstyle:{},
    },
    data() {
        return {
            mutexList: [],
            influenceList: []
        }
    },
    watch: {
        'data.userAnswerArr': {
            handler(newV, oldV) {
                if(this.data.questionsTypeId == 10) {
                    if (oldV) {
                        let add = newV.filter(v => !oldV.some((item) => item === v))[0]
                        if (add) this.getMutex(add, '', 'add')
                        let del = oldV.filter(v => !newV.some((item) => item === v))[0]
                        if (del) this.getMutex('', del, 'del') 
                    }
                }
            }
        }
    },
    created() {
    },
    methods: {
        getMutex (add, del, state) {
            
            let changeOid = add || del
            // console.log(add)
            if (!changeOid) return
            let { mutexList, influenceList} = this.data

            // 互斥
            if (mutexList) {
                this.setMutex(mutexList, changeOid, state)
            }

            // 互相影响
            if (influenceList) {
                this.setInfluence(influenceList, changeOid, state)
            }
        },
        setMutex(mutexList, changeOid, state) {
            mutexList.forEach(info => {
                let isOk = false
                if (info.oneList.length > 0 && info.twoList.length > 0) isOk = true
                if (isOk) {
                    if (info.oneList.indexOf(changeOid) != -1 && state == 'add') {
                        this.data.userAnswerArr = this.data.userAnswerArr.filter(twoOid => {
                            return info.twoList.indexOf(twoOid) == -1
                        })
                    }
                    if (info.twoList.indexOf(changeOid) != -1 && state == 'add') {
                        this.data.userAnswerArr = this.data.userAnswerArr.filter(twoOid => {
                            return info.oneList.indexOf(twoOid) == -1
                        })
                    }
                }
            })
        },
        setInfluence(influenceList, changeOid, state) {
            influenceList.forEach(info => {
                let index = info.oneList.findIndex((oid) => {
                    return changeOid == oid
                })
                if (index != -1 && state == 'del') {
                    this.data.userAnswerArr = this.data.userAnswerArr.filter(userAnswer => {
                        return info.oneList.indexOf(userAnswer) == -1
                    })
                } else if (index != -1 && state == 'add') {
                    this.data.userAnswerArr = this.unique([...this.data.userAnswerArr,...info.oneList])
                }
            })
        },
        unique(arr) {
            return Array.from(new Set(arr))
        },
        userAnswerChange(){
            this.$emit('userAnswerChange', this.data)
        }
    }
}
</script>

<style lang="scss" scoped>
.test_question{
    .option-box{
        display: flex;
        flex-wrap: wrap;
        // padding-left: 25px;
        box-sizing: border-box;
        .option{
            width: 100%;
            margin-top: 10px;
            display: flex;
            align-items: center;
            /deep/.el-checkbox__label{
                display: flex;
                align-items: center;
                white-space: normal;
                word-break: break-all;
            }
            /deep/.el-checkbox__input{
                display: inline-block;
                margin-top:3px;
            }
        }
        
            .other-input{    
                width: 100%;
                margin: 10px 0;
                /deep/.el-input__inner{
                    background-color: #f1f3f680;
                    color:#333;
                }
            }
        /deep/.el-radio{
            margin-right: 0;
        }
        /deep/.el-checkbox{
            margin-right: 0;
        }
    }
}

/deep/.el-checkbox__label,
/deep/.el-radio__label{
    display: flex;
    align-items: center;
    white-space: normal;
    word-break: break-all;
    font-size: inherit;
    text-decoration: inherit;
}
.group-title{
    font-size: 15px;
    color: #666666;
}
.group-list+.group-list{
     margin-top: 20px;
}
.el-radio-group,
.el-checkbox-group{
    padding-left: 20px;
}
.required::before{
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}
</style>
